<template>
<div @click="reveal">
    <div class="card green" v-if="cardValue === 'Green'">
    </div>

    <div class="card yellow" v-else-if="cardValue === 'Yellow'">
    </div>

    <div class="card amber" v-else-if="cardValue === 'Amber'">
    </div>

    <div class="card purple" v-else-if="cardValue === 'Purple'">
    </div>

    <div class="card red" v-else-if="cardValue === 'Red'">
    </div>

    <div class="card" v-else-if="cardValue === 'coffee'">
      <span class="card-image" >
        <img  src="../assets/coffee.png" >
      </span>
    </div>

    <div class="card" v-else>
      <span class="card-text">{{ cardValue === '.5'? '1/2':cardValue }}</span>
    </div>

  </div>
</template>

<script>

export default {
  name: 'Card',
  props: ['cardValue'],
  methods: {
    reveal() {
      const paramVal = this.cardValue === '?' ? 'question' : this.cardValue;
      this.$router.push({ path: `reveal/${paramVal}` });
    },
  },

};
</script>

<style scoped>
.card {
  display: table;
  height: 100px;
  width: 80px;
  background-color: rebeccapurple;
  color: white;
  border-radius: 10px;
  border: 2px solid white;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.6);
}

.green{
  background-color: green;
}

.yellow{
  background-color: yellow;
}

.amber{
  background-color: orange;
}

.purple{
  background-color: purple;
}

.red{
  background-color: red;
}

.card .card-text {
  display: table-cell;
  vertical-align: middle;
  font-size: 32px;
  font-weight: bold;
  text-shadow: 3px 3px 5px rgba(0, 0, 0, 0.6);
}

.card .card-image{
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.card .card-image img{
  height: 60px;
}
</style>
